import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  ProjectRegisterFeedback,
  ProjectRegisterFeedbackModalAction,
} from '../../project-register-feedback.model';

type B3ModalElement = HTMLElement & { open?: boolean };
type ModalHeaderIconTone = 'default' | 'neutral' | 'danger' | 'info' | 'success' | 'warning';

@Component({
  standalone: true,
  selector: 'app-modal-project-register-feedback',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './modal-project-register-feedback.component.html',
  styleUrls: ['./modal-project-register-feedback.component.scss'],
})
export class ModalProjectRegisterFeedbackComponent {
  @ViewChild('feedbackModal') feedbackModal?: ElementRef<B3ModalElement>;

  @Input() open = false;
  @Input() feedback: ProjectRegisterFeedback | null = null;

  @Output() closed = new EventEmitter<ProjectRegisterFeedbackModalAction>();

  get modalHeading(): string {
    return this.feedback?.heading ?? '';
  }

  get modalDescription(): string | undefined {
    return this.feedback?.description;
  }

  get primaryActionLabel(): string {
    return this.feedback?.primaryActionLabel ?? 'Ok';
  }

  get modalIcon(): string {
    switch (this.feedback?.variant) {
      case 'success':
        return 'check_circle';
      case 'error':
        return 'cancel';
      default:
        return 'report_problem';
    }
  }

  get modalIconTone(): ModalHeaderIconTone {
    switch (this.feedback?.variant) {
      case 'success':
        return 'success';
      case 'error':
        return 'danger';
      default:
        return 'warning';
    }
  }

  onPrimaryAction(): void {
    this.releaseModalOverlay();
    this.closed.emit('primary');
  }

  onModalDismiss(): void {
    this.releaseModalOverlay();
    this.closed.emit('dismiss');
  }

  private releaseModalOverlay(): void {
    const modalHost = this.feedbackModal?.nativeElement;
    if (modalHost) {
      modalHost.open = false;
    }

    document.querySelectorAll('dialog[open]').forEach(element => {
      if (element instanceof HTMLDialogElement) {
        element.close();
      }
    });
  }
}
